module.exports = __webpack_public_path__ + "ca.svg?960555ec61a2c450ad9a1aa9b3514a7b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ca.svg
// module id = 1213
// module chunks = 27